import { Component, Inject, OnInit, ViewContainerRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NotificationsService } from 'angular2-notifications';
import { AppService } from '../../../../app.service';
import { FECRUserInfo, GenericIdName } from '../../setup-implement/setup-implement.model';
import { ExistingProjectContactsVM, ProjectContactsVM } from '../add-fecr-recommendation/add-fecr-recommendation';
import { FrontEndComponetService } from '../front-end-componet.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-fecr-project-contact-dialog',
  templateUrl: './fecr-project-contact-dialog.component.html',
  styleUrls: ['./fecr-project-contact-dialog.component.scss']
})
export class FecrProjectContactDialogComponent implements OnInit {
  ImplementId: number;
  usernameList: FECRUserInfo[] = [];
  selectedName: number;
  email: string;
  role: string;
  contacteventsList: GenericIdName[] = [];
  loading: boolean = false;
  selectedEvent: number;
  selectedFrequency: number;
  ExistingContactInfo_:ExistingProjectContactsVM[]=[];
  ExistingContactInfo:ExistingProjectContactsVM[]=[];

  constructor(
    private _fecrService: FrontEndComponetService,
    private _appService: AppService, public dialogRef: MatDialogRef<FecrProjectContactDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private _sanitizer: DomSanitizer,
    public addRepairerWorkshopModal: MatDialog,
    public toastr: NotificationsService, vcr: ViewContainerRef) {
 
  }

  ngOnInit() {
    this.ImplementId = this.data.implementId;
    this.LoadUsers();
    this.loadContactEvents();
    //this.LoadProjectContacts();

  }

  loadContactEvents() {
    this._fecrService.getFECRContactEvents().subscribe(res => {
      this.contacteventsList = res;
    })
  }
  //LoadUsers for the logged User 
  LoadUsers() {
    this.loading = true;
    this._fecrService.getAccessibleUserLits().subscribe(res => {
      this.usernameList = res;
      this.loading = false;
      this.LoadProjectContacts();
    })
  }

  onSelectName() {
    let userInfo = this.usernameList.find(x => x.Id == this.selectedName);
    this.email = userInfo.Email;
    this.role = userInfo.Roles;
    this.selectedFrequency =1;
    this.selectedEvent =1;

  }

  AddUpdateProjectContact() {


    let params: ProjectContactsVM = {
      ImplementId: this.ImplementId,
      UserId: this.selectedName,
      EventId: this.selectedEvent,
      FrequencyId: this.selectedFrequency

    }
    console.log("Data", params)
    this._fecrService.UpdateFECRProjectContact(params).subscribe(r => {
      if (r.m_Item1 == 1) {
        this.toastr.success('Saved', r.m_Item2);
        this.LoadProjectContacts();
      } else {
        this.toastr.error('Failed', r.m_Item2);

      }
    })
  }
  onCloseClick(): void {
    this.dialogRef.close();
  }
  LoadProjectContacts() {
    this._fecrService.GETExisitngProjectContacts(this.ImplementId).subscribe(res => {
      console.log("result", res)
      this.ExistingContactInfo_ = res;
      if(this.ExistingContactInfo_!=null){
        this.ExistingContactInfo_.map(x=>{
          let userinfo = this.usernameList.find(z=>z.Id == x.UserId)
          x.Email = userinfo.Email;
          x.Role=userinfo.Roles;
          x.Name = userinfo.Name
        
          if(x.FrequencyId==1){x.FrequencyName='Immediate';} 
          else if(x.FrequencyId==2){ x.FrequencyName='Daily';}
          else if(x.FrequencyId==3) x.FrequencyName='Weekly';
          else x.FrequencyName='Never'

        })

        this.ExistingContactInfo = this.ExistingContactInfo_;
      }
    })
  }
  LoadData(data:ExistingProjectContactsVM){
      this.email = data.Email;
      this.selectedName=data.UserId;
      this.role=data.Role;
      this.selectedEvent=data.EventId;
      this.selectedFrequency=data.FrequencyId;
  }

  DeleteContact(data:ExistingProjectContactsVM){
    this._fecrService.DeleteSelectedUserFromContact(data).subscribe(r=>{
      if (r.m_Item1 == 1) {
        this.toastr.success('Saved', r.m_Item2);
        this.LoadProjectContacts();
      } else {
        this.toastr.error('Failed', r.m_Item2);

      }
    })
  }

}
